/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Card, Divider, Input, InputNumber, message, Modal, Space } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { IoIosSearch } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { CustomItemModal } from "../modals/Products/customItemModal";
import { ProductModal } from "../modals/Products/OrderProductModal";
import { ReserveItemModal } from "../modals/Products/reserveItemModal";
import { Spin } from "antd/es";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { deleteDraft, editOrder } from "../../../../store/draftSlice/draftSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import _ from "lodash";
import { setLoading, setOrders } from "../../../../store/draftSlice/createDraftSlice";
import { Money } from "../../../../components/Money";
import { DiscountModal } from "../modals/discountModal";

interface ProductCardProps {
  setUnsaved: Function;
}

export const ProductCard: React.FC<ProductCardProps> = ({ setUnsaved }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [productFinder, setProductFinder] = useState(false);
  const [addingCustomItem, setCustomItem] = useState(false);
  const [addingDiscount, setAddingDiscount] = useState(false);
  const [reservation, setReservation] = useState<{ date: string; time: string }>();
  const [reservingItem, setReservingItem] = useState(false);
  const [reservedDay, setReservedDay] = useState("");
  const [product, setProducts] = useState("");
  const [LineItem, setLineItem] = useState<number>();
  const [Delete, setDelete] = useState(false);
  const loading = useAppSelector((state) => state.newdraft.loading);
  const orders = useAppSelector((state) => state.newdraft.orders);
  const selectedCustomerdata = useAppSelector((state) => state.newdraft.customer);
  const billingAddress = useAppSelector((state) => state.newdraft.billingAddress);
  const shippingAddress = useAppSelector((state) => state.newdraft.shippingAddress);

  const date = new Date();

  useEffect(() => {
    reservation &&
      (moment(date.setDate(date.getDate())).format("MMMM D, yyyy ") ===
      moment(reservation.date).format("MMMM D, yyyy ")
        ? setReservedDay("Today")
        : moment(date.setDate(date.getDate() + 1)).format("MMMM D, yyyy ") ===
          moment(reservation.date).format("MMMM D, yyyy ")
        ? setReservedDay("Tomorrow")
        : setReservedDay(""));
  }, [reservation]);

  return (
    <>
      <Modal
        visible={Delete}
        onCancel={() => {
          setDelete(false);
        }}
        title="Delete"
        okText="Delete"
        okButtonProps={{ color: "red" }}
        onOk={() => {
          setUnsaved(false);
          orders?.id && dispatch(deleteDraft(orders?.id));
          navigate(-1);
        }}
      >
        You cannot delete the last item from the draft. Would you like to delete the whole draft?
      </Modal>
      <ReserveItemModal
        open={reservingItem}
        setOpen={setReservingItem}
        CustomerId={0}
        setReservation={setReservation}
        reservation={reservation}
      />
      <CustomItemModal open={addingCustomItem} setOpen={setCustomItem} CustomerId={0} />{" "}
      <DiscountModal
        open={addingDiscount}
        setOpen={setAddingDiscount}
        lineItem={LineItem}
        setLineItems={setLineItem}
      />
      <ProductModal
        open={productFinder}
        setOpen={setProductFinder}
        search={product}
        setSearch={setProducts}
        Customer={selectedCustomerdata}
        billingAddress={billingAddress}
        shippingAddress={shippingAddress}
      />
      <Card style={{ cursor: loading ? "progress" : "default" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p>Products</p>
          <div style={{ display: "flex" }}>
            {/* <Space>
              <p
                style={{ color: "#1890ff", cursor: "pointer" }}
                onClick={() => setReservingItem(true)}
              >
                {reservation ? (
                  <>
                    <span style={{ color: "black", cursor: "default" }}>Reserved until</span>{" "}
                    {reservedDay} {moment(reservation.date).format("MMMM D, yyyy")} at{" "}
                    {moment(reservation.time).format("h:mm")}
                  </>
                ) : (
                  "Reserve items"
                )}
              </p>
              &nbsp;{" "}
              <p
                style={{ color: "#1890ff", cursor: "pointer" }}
                onClick={() => setCustomItem(true)}
              >
                Add custom items
              </p>
            </Space> */}
          </div>
        </div>
        <div style={{ display: "flex" }}>
          {" "}
          <Input
            disabled={loading}
            placeholder="Search Products"
            style={{ width: "100%", marginRight: "10px" }}
            // onSelect={(val) => setPromotionActivation(val as string)}
            // disabled={!!promotion?.id}
            value={product}
            prefix={<IoIosSearch />}
            onChange={(e) => {
              if (selectedCustomerdata) {
                setProductFinder(true);
                setProducts(e.target.value);
              } else {
                message.error("Please select a customer first");
              }
            }}
          />{" "}
          <Button
            onClick={() => {
              if (selectedCustomerdata) setProductFinder(true);
              else {
                message.error("Please select a customer first");
              }
            }}
            disabled={loading}
            loading={loading}
          >
            Browse
          </Button>
        </div>
        {loading ? (
          <div className="d-center" style={{ height: "50vh" }}>
            <Spin size="default" />
          </div>
        ) : (
          orders?.line_items &&
          orders?.line_items?.length > 0 && (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                  padding: "0px 8px",
                  marginTop: "1.5rem",
                }}
              >
                <div
                  style={{
                    textAlign: "left",
                    fontWeight: "bold",
                    gridColumn: " span 2 / span 2",
                  }}
                >
                  Product
                </div>
                <div style={{ textAlign: "left", fontWeight: "bold" }}>Quantity</div>
                <div style={{ textAlign: "left", fontWeight: "bold" }}>Total</div>
              </div>
              <Divider style={{ margin: "0px" }} />
              <div style={{ maxHeight: "500px", overflowY: "auto", paddingTop: "24px" }}>
                {orders?.line_items?.map((x) => (
                  <div
                    style={{
                      display: "grid",

                      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                      padding: "0px 8px",
                      alignItems: "start",
                    }}
                  >
                    <div style={{ display: "flex", gap: "4px", gridColumn: " span 2 / span 2" }}>
                      {/* <img
                    style={{ height: "40px", width: "40px", objectFit: "cover", marginTop: "6px" }}
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQMAAADCCAMAAAB6zFdcAAABWVBMVEXAqf0AAABiUmq5rNutorWNerVGNkrIsP9hUWlmVW7Jsf/DrP/Grv9IN0xeTmZENEjAsuOTf72KdrJjU4ZNPVKrmrO3ofFbS2InIjMYFBqmla59bYWkkNj///89NlCDc4sjGyWLe5NqXYxOQlUxKTU9M0JQQ1dEPFkqJiyxo9QqICx2aJynk9xTSW10bImCcqtxYXnug5CpnciZjaEZFhqFeItNRlFgVX+hkcZsW5EzLUNYTXRvYHc6LD0dGSZ2a3xdVGGYhr6MgqYcGh42MkBUTmOHc7iAd5hGP0nZ2dmaVl8aFBydkro6NkU/LkPCtsp+cKBsYXF1Y5+OesAyKUdhYWGKioqnp6dAQEAuJyiSdHq8lZwWFhb/wMv9qrb2l6N0dHTOc356REvidISeT1uvR1lfICw+FR2SNkfk4e69vrx6ICC/OzuRLS0uLyyQICDlQ0MjBwfSxNpzLKwXAAAUuUlEQVR4nO1d+2Pi1rH2iEUPhA4Sy0vgxbxtgzFeYxYb/Fq/dhPWaZ3c3ps0m1fTpG3a5Lb3///hzowECIzt3U1sTHu+H7wYI6TzaeabmXPmaJeWJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJBYSZtSc6/GPAJrT2NA+fBSmtlxa1n7D65kDok0AyH/oKEzNyeDxpYUmQWvC6dUOQDMV/ZCjN/IAa1eLTYLWADCKySO8l63I+x5sRvHo006yKACchdUEcwMgrQhk4Rhgden9xhFNoRtcJYu6UGoA93SF9w+tB6qhKLrYyhbRId5LFTQH3aCdNYSiKEYF+gvqDaYDrkFDMHRRTL54L3/QSgDHyRWhG/QNCsDGYnoDmkEZR1CDqmKILVKFd9Y2Cied7L4wRAXQEozqghoCqsEOUmC4qIg1QxjZIrzrSMw8vG23dd1Q8di6wYZwz1d7P4iW0AAUowxn5wBV9Id2G0l4F3cwe3CaLQrFqANsuiirpAjxRXSGiMtmPIAT+/d8N5mE7t0kaHlYyxZx5GhBb+xNqLBDrS6gM6ArkCKmwbVDTsuFgqGki0hC466xRPpkBWlF34FM+GUoBOCp4gLagRlGByA127TX4+HwYGQJzu0pI+VVRAHqSC8cjofsc1JWowDLi0dCtMvX7sJ2iDiIu2TTItsBSN12mLkM0CYKCmgFeNi6fUIHIpetxeMAvRpdWgewQ7vIgdMC5ERXssfQu9UbAI6ygsbshpkDcgaDpLX7ISXHfBFhP67BuR16GY439p72KXHW95Nr0Lp5NFofXicVndLjp0/3GvHwbsgukLamF1EUTbp9iopyYIf3niL28iSSYqV9izeQJ2Rzgsyn6R20S4JQUxQBmcXjIEUjRpN+Ze/iaBotdIdDUsk0ekPzpuFoGTjyEoO8Ew639ogEe5+FBWARORgYlNucvLzYa4QZLc8bsjdm/1hhrKEnGOgJ3hHxvb2L3U1QFeLgvavvuSMFp8zB7y8uwj6cJmUJonh1kyFEMtBZETTe0vCY8MVFl/PNxeTAZQ72LtZ3RwNyKTYY2aEimKYZJeC//OsyJogcE3qOf0B8d/eiTxwoi+gLSxzSqvB016bY6BlCicooUTyGRtSMauaG02qUuqVGy9nA32jm7QjNAIfbGpKG+QFaT4KC7AJqYoTjQhW6NudIPjJQRkVogxtJNfIQxGorhaEkqxNveWfMQSi0SnFhIWMj50iY2pyPOGg1nmKSQPExW4Eejfv18dVRp9M5ujo+o197cFzkuOilBsxBKGRfel+0gDmSlyun4cwOhTyJ53iPhmAYx6cAO8fFZLa4kts3EFu5lf0XbwHWFIPMwPsosYA1k+0b1ALmymaLayaAUAgTxfCnTzlJcBrgKgUcbCeZXTGE0AkK/zTwXgPWBqwGlBo8baAkhkLbHGTri1gzUe2s0LW/CaEzUJrkySItmsBRsr2VFroyCbIBUgZnaDd7KAf2K+JSLOZEkgZgkcBtoSDgTW2NcgR4nc1upacJ8FhIuwBdXxFbSIIdsssoifrBHZXWI0W0DwcJbw7ls72n8TEFV8niNRMYQRSCJHzqeGWjVcdoOu8BfQAw8R1YluHCm5cXFwEr6CRz6ZsYIBLqARIuLnZPoKKoFmZViycHS1w5xlSrCuefXay/9CjoEgVb4hYK0B2QhIZHAiaJn52BqloL6go8sVy3VBXg4qXtpQglomD/VgoQtbqfKKIiOp+iqqjWYDGnlZeoZKB7WIBmyEsRWqQFt1sBW0Ki4NWNmBys/xdULCu2kDOqDMz/6zyAUCjkzau+SObupABrA8ulqony5G2fxoVRRFOLasGeE3NoCPuYK7508rCGEeFuCrA4QN76zi7nyehOscnkAE8S/RWtLfcKc7lHpc/S+JZpXSjwELbRElAP2+13ogAl4QB1EY95w2rgBmcgo6kGneZxrsFStwEjuLwMcKBicL+0yao7WeXGvGAKiTp5kO3S4RU4HFHAjRmMeQzxTphhtPVk8XWw3SIaZm8AOLELcJzcelcKWBLK9ia4bEajUsGkxozjdjL79rGWDwADfYXaLQ5Hb0VWyRvQss+RoJV39AQCScI+JxjueMmeBGatnc2lsc5+nCJppg7BFaKYrUBmfJOAghsGOxQDSg+Nu4fvtV0kDsA/NBMdnQAwsqwIpCA/nyHeDXOpB64hcsm18aQprRgcWJgoXWUpB6xWq7U7aChXq6rASpGIs1AMxllyNIMUbAlafHi8WaOp5aGCJGQxxxnePA0zo1gdzpI5neohhDvBgmFM/Fb2FK+CmRISVzkIiIFWQn/aEliB9COPUwxQsrVUHGuimiKKxYBuR0o0qHZRiNHcYXk0/rRarVTL6SEN3gQCYUfRSUaQzJFFbfAaFH2k66S0R9jCG9WWS4d0zaeYBtFaUndkrpEu9Vd5TTkAf/jovwGEf9Ndf8QD3zRqAP/z0eeeJRgJLBOgNfoatLEj6szo8J8zjQ3tUcmiqaUaNJy1406Wmmh4LWm0qEhSll3RfSt/9uzZKbeWcKvNF3/88ssv//gF+O8U4A/Pnn3kfTCdprA4zgyWYSeLsVUvZtud4x2ioZV6NOmiqTmrRMBRO1vMKTw9QksII0OIdlEQhVHxhvbRs2fAs6TGAN5++dXX33zzzddffQm0AkUrC788e/aT98GqQWn2aCY1kvcWHxQhjBzycLWGn2kuPwoWzGiYfOAKCdgXuqELmiULrCXxPEI2pxsF3+6/fcscICeff/XNcw/ffPUFr8fiX3751v9cxaDEYjhvgGZwmqX+Jj3NZ9lCGo5pPt6ZOwumFgaeJWYCatXCoHBg0VJ58WrYiIdX/5pW0IYcMHi8Xz//7mOm4OPvnn9NIpEOfgQFgeePvBNFerwUqSTUSmFQr6aJhnby6BRdwplrlDAjDtrAWRG9XcfYPxS4WALrgtHqMmb4vJ5eDYxvQFPIOH6gH8//BEA/qoYR5KBMHBT8dm1akSYzoErcC7BVYQilmOygS/Q25pcuaCnUgUqRmiaMMt3mTL/BsUGtsSGscvEUbUKHCoXgTa6SWXz3/DuPg4+BX9eNoWYwdLznmCJ5MwfRQ+jk8B2moNdo0mnqZTSGlWwHbaH/QXsDfj24hNvpcNsI3WO32XKcPhyGMzCw0oqe9OsabRXaHAnHA9wxSBFp9B8///7775//CZn4jlRRD9BkKJaKglCi0UVbcIZmkMa0KR+n6Uan0fQ+hCzw3oD4PExB2+De+hWMA8RAvuQ4PFvWohX2iqWIlY6X6SMH3szJWBEEM/JnJOH7H378y48/fI+v/sztZyNjwV/02IgDrDraW7quYvHgOCWeaXPCJVquUQ0doyWqY/7hTSHSoBKurQgjATRz4viLSH18gX+KoTdkve4r8gWvZub2Y+BuAk6H/vrDX//C7/yIr6hHhWSfrcWlZu90bOgLWhdeYMVFZRS1uOX9pSiHlq7fci90Gx3CedgmDXMp782P8sJQvuWvB3Th0PFWEVxL6Dmv+ypagqvhvIEhamm/Ppjwff/O8/tKuib4MwmVpl9QE7lTa589wetPQW/w1ysaaAtrqMc52ibSf8j8OYqp+2m7iMEA3eCQFwPi8fj42hzgJSYM4CiLKOkvZpWKacB8zx//cacD1xZeVJUmDzC4oCBSZEFCDp0x1/G439ZBDoGmgDl05uEWYmiPyQsqX8gI+sxAeHc9ZO/DuRP3OYBYWjGSO1Q/pjgtvAYDfvrbsF5w//bTtc/UkAOVkmWsF88wS67FwO/Rib88gxM75C/chDE4FXQlvZJFy1p+IFEgKbjKGlzBZcgN4uH1UIjnwUMh7j2irKFAslik6l/rUTPNdQ6qn1NK+Pd//Iw/v/3lYJoDoqAC3Sh372LhbZHXeWez3/B8PZ2N9IFqlbIhtkganQeJD1QLd9oYEAueEfgMUC/lpk3NBnFvgR29QXBnrtmCwcyJRCwL4X//+c9//oOzpqk/JjxXwPAKcISn43kl1ML4SzpX2TuXzwKZQoXysqNgoXmPFHS5qZp6CF1SAmqTCI3MgC8r7vRgFWWRvGGNdiwAdRjOsgSAf/3955//xdnAJDAoUGQ81LBkfp3UWRCbyIF/utHJQl43NKlC2hDtzkOQQFbQXmE/WGXXHF7K0AxoTSmch1YG6ugNFBvieMygNpMEfwLBvTa/pqueGTh47E5ySxeYGuRL0PRtLng21AUyhR4RKYqdwKzLPYFmxto5IfDaS47XNjZtBnRVq1CiKTSMDXRRy1H0jJnr7YZRU6vV9HXJtIiCCmQiLaZcsdATwn3ors86nWcKfdQghUm432l30qciT4eQGI6NYPLGhOxN6NI1qZi/kI9uOBwnZmNGzNCJAppBoQM7lB3FiPMmRYNZ50PLI2lEi6qJ4tEdOyR+NYAidR1dM6gEfBXB+2K/gn4YRYHqBtqxAKkmvp4VHGZCqL4nNJa93Qw11UUpcFaptylgCHbg/NwHiolbVbTv2iHx64BV0ou26otheD1wCZgbbAUu6QQ9l+qGAusikrCcwdfWuy0zsRxSz8GqQxRgpoCvM07YueR1y+EZy/AqSMK6L41uDXP0e9wfreE1UUBrhp2gHxCCZkBrped4TejLdSut7xMJWFQXLHWmMk4ZQWJIQa80pKBAm1ri6xVYnzhHwZ64BNosQ5N6lSvI358hREjEM9Riuvpy4vxo/OfBN7bhkrqUG0MSjqgJFd1BVW9rRRozoKLx0xEdnwKsRuO79qT125Wga9Ab5AuwyjMM98eB6fRWnWgkRdF4c+J63KCZklmc2pgsOUxCTeE9roQYslC7adURqyWfAYtXFrAkaWOKrA48CvBL3QniT6A88fs+HtJIRZZa+fx9RgaTeyzM6BKycLYevJzLSbtg1/C0uoAeoLezr3lYdctSY1YirV+LBiKdUH0GVG+i4Zg6NhJkES0OQdvc9ztxkjHx9jZ9zoyOLvL+odEi+PbwkuxLOJk0yzV2Xa8HyY0ldJFLdna8EhlZUGMxNZGo1dIearWEFfN9ABmo8+fWitktIWj+cECSH2KRmeRgkxtcvNcn6AUPPYtial3aietdwTa8nZQnFG3yVdLq1iEtuqZ1pZg88lioxyxLnQ3LOvBsgGaqMUEmp+iFPQrQ2DYnzzIWYqKgMYd9LlQ+eraIgXHq6vAdNox1P2rXMTkQ/FSQU/IJt36Aw7Wmhm+pB2wChTpWCEVD6AlyiuYwHcXb/mrqLOf+O1RHPkzBeI2E0vA+wETQCl4vZ7Fd8geLngryAo6z3kDBLdQPDg7YBWIxfFUvcO3gopWg/SvCM4JARo4jnnQ48o6K7dnhnChAEprsoWiI51NGinbruyrNczjkD3U1IQwqNj5Bg68PYBYGFXYTzBBrGCQLvh/4+ah9ORV7WHbI5TBKzvHJOUDXYJ9NBWq+Q8O4NepTRlVIwNvkPsU/NPzYQb1eGLgeBoV65WAkE1YdnYemG7lveZiN2TswfRZMSxSbjG6OnbymQ7na9lTc9txjlMR5s2utHtk5vEjSvt0Eu4A1AZXChWpxeEAncKk292YPR18JM04D/GOeDd2RHpZyW9f0mmP38D1/Z5/D7QlH3KFIc8cUDmN+ROQXVoKzp1qMG9kg4/dtj8rz7akchE+DGkFF6jxbc7CWvpxIVUYXdzZ+c7hHjSqaYrBRVRecHFCaENjQUGNBKA23to3qkhmqQz5H57/fWvkuaC68wssYIniDRhox3t44gGyAA10IoezncrktA1+NSNBjtNQ62ug6LNDR9wPmNjrjWzz/nHf9Rbl0eHVOClY533wT8i8zGMzHHFA/ihgxoKy0nwzRLm6lh39hUez6x4xcwTZGodEOnWyW1wB2zs5PaKk6PN8OBJpYmsC5nzuejPPYEQdhDAs5737r6f0xAT46wmPBolm0/jU78EOjbZ+Up845X1fgJhM4bCynzEg0tdyiEFhhFgIKNhwN1g47PgdCucYAgTf5GAlaV2gO9cAZcuAlZPYJpVL9+EZKi5gpnk8+nHezYrR76ET8dT7T1JbCWEtdUjE1DAz2brxRKpVob+OIA5GbxQC5BMnCkIMWHxff9bmkCGy/WaOFlqhm+meMai13/ps/p7YSmBotMr2ybRc8wz0fmWym6XMgVm6g4MmTrPBbLzKZUfJosGFR1oUqA73lyNQJ507BdXBvxjlVjjZqOdlqs1sq9b0d3tS3faMVsCWkSQ+4pFjtl0rdVcqqCydIJoaFS1o8eIRDngFtA6C8CSfra7Q6tqRp9IwDTdvgJx8J3biFgidPioK3vpRSw8NStHxyGcJAg9Yxp56bDwB1sFO7PvQ2AoZrYlZZbAsxUw7HMGL+OuP4uOVDWEMbgLy5GEbAMJe4N6s06brRLhxl07ebAYbITyhXnvw6k7uP8gtjBAzqz0UKpt6MY81kdO7goP0J1kzTD73QVrGMerjL/20Qbc3YcpQiUbzDFZ5s0YxiaeqWU9P6I929cwvM1vWtqVoPOtm7OBA1a8bDg8xGeLE8gTFDv/j5R3fJgV677gqzv24xEXXh6Hd3mIGSWOTnKd8NNAR4cisJ+9TgvqCb3N8RWhPW/u8WEjqCGjkX81kH7wwzA69vJqGTJgrueNLmwgNzRTj93Q0k5Hi3y1zarx8UPGU8Uxjb3tOBDhfv2XDvB3MZCrSfG46mpbG9n6YlZted+7TQfQM5qChWjAri0+POMF1qd/atA156OrAW8gG67wXiwFBqaqzuz5C83Rn2LAMMDqyEXvm358B7rGJaT6hWrBLY5eUO6geWatXSmB08zsc7/IbQAIRKz42jhSaASAqxQQ9JUK0EbWVezAdqvx+iJahUoIYRoGwM/Gd8aCVwhXEKtK+j/pj3tP9mINOnfb61yujJBuYh1HH8ZY6N//Zy4JUMO7qBCjjOiWnGxa2gWmKSONf104cC7YLx5trHZYGZGj5Y9D+CAnq6T5e2pIQndmBp3KbRXPT/k+vdEdUikel1AhPffIwPdpCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkPhA/D/wP0fiWqJGqgAAAABJRU5ErkJggg=="
                  /> */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "start",
                          marginLeft: "4px",
                        }}
                      >
                        <Link to="" onClick={() => {}} style={{ textAlign: "left" }}>
                          {x.name}
                        </Link>
                        <div style={{ textAlign: "left" }}>{x.variant_title}</div>
                        <div style={{ textAlign: "left" }}>sku : {x.sku}</div>
                        <div style={{ textAlign: "left" }}>Unit price : ${x.price}</div>
                        <p style={{ textAlign: "left" }}>
                          Discount :{" "}
                          <span
                            style={{ color: "#1890FF", cursor: "pointer" }}
                            onClick={() => {
                              setLineItem(x.id);
                              setAddingDiscount(true);
                            }}
                          >
                            ${x.applied_discount?.amount ?? "0.00"}
                          </span>
                        </p>
                      </div>
                    </div>
                    <InputNumber
                      value={x.quantity}
                      style={{ height: "30px" }}
                      onStep={(e) => {
                        console.log({ e });
                      }}
                      onChange={_.debounce((e) => {
                        parseInt(e?.toString() ?? "1") &&
                          parseInt(e?.toString() ?? "1") !== x.quantity &&
                          dispatch(setLoading(true));
                        parseInt(e?.toString() ?? "1") &&
                          parseInt(e?.toString() ?? "1") !== x.quantity &&
                          orders.id &&
                          dispatch(
                            editOrder({
                              id: orders.id,
                              data: {
                                line_items: [
                                  ...orders?.line_items.map((y) =>
                                    y.id !== x.id
                                      ? y
                                      : { ...x, quantity: parseInt(e?.toString() ?? "1") }
                                  ),
                                ],
                                applied_discount: null,
                              },
                            })
                          )
                            .then(unwrapResult)
                            .then((res) => {
                              dispatch(setOrders(res.data));
                              dispatch(setLoading(false));
                            });
                      }, 300)}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "start",
                      }}
                    >
                      <div>
                        <div>
                          {x.applied_discount && parseInt(x.applied_discount.amount) > 0 ? (
                            <Money
                              value={
                                (parseFloat(x.price) * x.quantity -
                                  parseFloat(x.applied_discount.amount)) *
                                100
                              }
                            />
                          ) : (
                            <Money value={parseFloat(x.price) * x.quantity * 100} />
                          )}
                        </div>
                        {x.applied_discount && parseInt(x.applied_discount.amount) > 0 && (
                          <div style={{ opacity: "50%" }}>
                            <s>
                              <Money value={parseFloat(x.price) * x.quantity * 100} />
                            </s>
                          </div>
                        )}
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (orders.line_items.length > 1) {
                            dispatch(setLoading(true));
                            orders.id &&
                              dispatch(
                                editOrder({
                                  id: orders.id,
                                  data: {
                                    line_items: orders.line_items.filter((y) => y.id !== x.id),
                                    applied_discount: null,
                                  },
                                })
                              )
                                .then(unwrapResult)
                                .then((res) => {
                                  dispatch(setOrders(res.data));
                                  dispatch(setLoading(false));
                                });
                          } else setDelete(true);
                        }}
                      >
                        <MdDelete />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )
        )}
      </Card>
    </>
  );
};
